import Service from "@/services/Service";

export class CreativesService extends Service {
  static getMgidAuthToken (
    email,
    password
  ) {
    return this.api.post(
      "auth/token",
      {
        email,
        password
      },
      {
        headers: {
          "Referrer-Policy": "origin-when-cross-origin"
        }
      }
    );
  }

  static uploadFileToCdn (
    file
  ) {
    return this.api.post(
      process.env.VUE_APP_FILE_API_URL,
      {
        file
      },
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
  }

  static createCampaignCreative (
    token,
    clientId,
    data
  ) {
    const formBody = Object.keys(data)
      .map((key) => {
        return `${ encodeURIComponent(key) }=${ data[key] }`;
      })
      .join("&");

    return this.api.post(
      `goodhits/clients/${ clientId }/teasers`,
      formBody,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${ token }`,
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  }
}
